/********************* 请求配置 *********************/
import axios from 'axios';
import { Message, Notification } from 'element-ui';
// import router from '../router';
import jsonBigint from 'json-bigint';
import {getToken, removeToken} from './auth';
import serverConfig from "@/serverConfig";
import abortHttp from '@/utils/abortHttp';
// import env from "../../env";
// 引入请求终止方法
let abortHttpDefine = new abortHttp();
// store.dispatch('projectConfig/setAbortHttp', abortHttpDefine);
const statusLogin = [
    11001, // 未读取token
    11002, // 账号信息错误
    11011, // 未读取token
    11012, // 无效token
    11013, // 过期token
    11014, // 顶下线
    11015, // 踢下线
    11016, // 账号冻结
    401, // 未登录
]; // token失效
const jsonBigStr = jsonBigint({ storeAsString: true });
let notifyLogin = null;
// axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000;
axios.interceptors.request.use(
    async (config) => {
        /**标识对应的请求，并在需要的时候终止**/
        // store.state.projectConfig.abortHttp.addAbort(config);
        // if (getToken()) {
        //     config.headers.Authorization = getToken();
        // }
        // console.log(env);
        // config.headers['Access-Control-Allow-Origin'] = '*';
        // config.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, application-id';
        // config.headers["application-id"] = env.VUE_APP_APP_ID;
        // config.headers["application-token"] = env.VUE_APP_APP_TOKEN;
        config.headers.Authorization =  "Bearer " + getToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axios.defaults.transformResponse = [
    function (data) {
        try {
            return jsonBigStr.parse(data);
        } catch (err) {
            return data;
        }
    },
];
axios.interceptors.response.use(
    function (response) {
        const res = response.data;
        return response;
        // store.state.projectConfig.abortHttp.deleteSingAbort(response.config);
        /*if (statusLogin.includes(res.code)) {
            if (!(response.config.params || {}).isLogOut) {
                !notifyLogin && (notifyLogin = Notification({
                    title: '提示',
                    message: '您的登录信息已失效，请重新登录。',
                    type: 'warning',
                    duration: 1000,
                    onClose() {
                        notifyLogin = null;
                    },
                }));
            }
            if (res.msg.indexOf('http') === 0) {
                window.location.href = res.msg;
            } else {
                router
                    .replace({
                        name: 'login',
                    })
                    .catch(() => {});
            }
            return new Promise(() => {});
        } else if (res.code === 403) {
            Message({
                message: res.msg || '没有该操作权限！',
                type: 'error',
                duration: 5 * 1000,
            });
            return Promise.reject('error');
        } else if (response.status !== 200 && res.code !== 200) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000,
            });
            return new Promise(() => {});
        } else {
            return response;
        }*/
    },
    function (error) {
        //  1.判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
            Notification({
                title: '提示',
                message: '请求超时15000！',
                type: 'warning',
                duration: 2500,
            });
            setTimeout(function () {
                location.reload();
            }, 300);
            return new Promise(() => {});
        }
        if (error && (error.response || error.message)) {
            if (error.message === 'cancelHttp') {
                return new Promise(() => {});
            } else if (error.message === 'canceled') {
                /**手动终止的请求不计入失败(常用作tab切换时候)**/
                console.warn('手动取消的请求：', error);
                return new Promise(() => {});
            } else {
                let status = (error.response || {}).status;
                let code = ((error.response || {}).data || {}).code;
                if (status === 403) {
                    /*router.push({
                        name: '403',
                    });*/
                    return new Promise(() => {});
                } else if (status === 404) {
                    // router.push({
                    //     name: '404',
                    // });
                    return new Promise(() => {});
                } else if (statusLogin.includes(status)) {
                    if (!(error.config.params || {}).isLogOut) {
                        !notifyLogin && (notifyLogin = Notification({
                            title: '提示',
                            message: '您的登录信息已失效，请重新登录。',
                            type: 'warning',
                            duration: 1000,
                            onClose() {
                                notifyLogin = null;
                            },
                        }));
                        removeToken();
                        window.location.reload();

                    }
                    return new Promise(() => {});
                } else if (status !== 200 && code !== 200) {
                    return new Promise(() => {});
                } else if (code === undefined) {
                    return new Promise(() => {});
                } else {
                    return response;
                }
            }
        }
        return Promise.reject(error);
    }
);
const getApiRoot = (type)=>{
    let api = process.env.VUE_APP_API_ROOT;
    switch (type){
        case 'DOCUMENT':
            api = process.env.VUE_APP_API_DOCUMENT;
            break;
    }
    return api;
}
export const POST = (url, params, type) => {
    let api = getApiRoot(type);
    return axios.post(api + `${url}`, params).then((res) => res.data);
};

// + '?time=' + new Date().getTime()
export const GET = (url, params, type) => {
    let api = getApiRoot(type);
    return axios
        .get(api + `${url}`, {
            params: params,
        })
        .then((res) => res.data);
};

//并发请求
export const requestSpreads = (reqArr) => {
    return axios.all(reqArr).then(
        axios.spread(function () {
            let reqReturn = [];
            for (let i of arguments) {
                reqReturn.push(i);
            }
            return reqReturn;
        })
    );
};

export const PUT = (url, params) => {
    return axios.put(process.env.VUE_APP_API_ROOT + `${url}`, params).then((res) => res.data);
};

export const DELETE = (url, params) => {
    return axios
        .delete(process.env.VUE_APP_API_ROOT + `${url}`, {data: params})
        .then((res) => res.data);
};

export const PATCH = (url, params) => {
    return axios.patch(process.env.VUE_APP_API_ROOT + `${url}`, params).then((res) => res.data);
};

/**
 * 埋点部分接口需增加taskSource字段
 * @param params
 */
export const addTaskSource = function (params) {
    let taskSource = sessionStorage.getItem('TASKSOURCE');
    if (taskSource) {
        params.taskSource = Number(taskSource);
    }
};
// 返回http包裹的响应体 + '?time=' + new Date().getTime()
export const GET_ORIGIN = (url, params) => {
    return axios.get(process.env.VUE_APP_API_ROOT + `${url}`, {
        params: params,
    });
};
export const POST_ORIGIN = (url, params, timeout) => {
    if (timeout) {
        //自定义超时 - 时间
        return axios.post(process.env.VUE_APP_API_ROOT + `${url}`, params, { timeout: timeout });
    } else {
        return axios.post(process.env.VUE_APP_API_ROOT + `${url}`, params);
    }
};
// fetch keep-alive 页面关闭继续完成请求
export const FETCH = async (url, method, params, noHeaders) => {
    let options = {
        method: method,
        keepalive: process.env.NODE_ENV == 'production', // 本地无法请求非同源fetch keepalive
        mode: 'cors',
        credentials: 'include',
    };
    let headers = {};
    if (!noHeaders) {
        options.headers = headers;
    }
    if (method.toUpperCase() === 'GET') {
        // url += (url.indexOf('?') >= 0 ? '&' : '?') + qs.stringify(params);
    } else {
        options.body = JSON.stringify(params);
    }
    return fetch(process.env.VUE_APP_API_ROOT + `${url}`, options).then((res) => res.json());
};
